module.exports = __webpack_public_path__ + "static/media/id9-lido_azzurro.d1253f00.jpg";